<template>
  <section>
    <div>
      <form @submit.prevent="searchInfo" novalidate>
        <div class="t-body3 mgt-6 t-color-content1">
          {{ $t("2") }}
          <!-- 계정을 검색하려면 이메일 주소 또는 휴대폰 번호를 입력하세요. -->
        </div>
        <div class="mgt-38">
          <div
            class="mdc-text-field mdc-text-field--outlined w-full"
            :class="
              submitState && searchValueInvalidCheck
                ? 'mdc-text-field--invalid'
                : ''
            "
            id="searchValueEl"
          >
            <input
              type="text"
              class="mdc-text-field__input"
              id="searchValue"
              name="searchValue"
              v-validate="'required'"
              ref="searchValue"
              maxlength="50"
              :value="searchValue"
              @input="handleSearchValueInput"
              v-lowercase
            />
            <div class="mdc-notched-outline">
              <div class="mdc-notched-outline__leading"></div>
              <div class="mdc-notched-outline__notch">
                <label for="tf-outlined" class="mdc-floating-label">
                  {{ $t("3") }}
                  <!-- 휴대폰 번호 또는 이메일 주소 -->
                </label>
              </div>
              <div class="mdc-notched-outline__trailing"></div>
            </div>
          </div>

          <div class="t-helper t-color-red1 mgl-7 mgr-7 pdt-2 min-h-23">
            <span v-show="submitState && searchValueInvalidCheck">
              {{ $t("7") }}
              <!-- * 휴대폰 번호 또는 이메일 주소를 입력하세요. -->
            </span>
          </div>
        </div>

        <div class="mgt-38">
          <button class="mdc-button mdc-button--raised btn-red">
            {{ $t("4") }}
            <!-- 검색 -->
          </button>
          <button
            class="mdc-button btn-white mgr-8 mgl-8"
            @click="cancelFindId()"
            type="button"
          >
            {{ $t("5") }}
            <!-- 취소 -->
          </button>
        </div>

        <!-- <div class="t-body3 mgt-30" v-if="externalAuthCode">
                <router-link to="step2"> -->
        <!-- {{$t('6')}} -->
        <!-- 인증코드로 계정 찾기 -->
        <!-- </router-link>
            </div> -->
      </form>

      <!-- find account by code -->
      <!-- <div class="t-body4">                    
                <div class="t-color-blue1 mgt-21">
                    <router-link to="/findcode">
                        {{ $t('6') }}
                    </router-link>
                </div>
            </div> -->
    </div>
  </section>
</template>

<script>
/**
 * 계정 찾기 Step1 컴포넌트 (find account Step1 component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCTextField } from "@material/textfield";
import { MDCRipple } from "@material/ripple";
import findApi from "@/api/findApi.js";
import { mapState, mapMutations } from "vuex";
import { findIdMixin } from "@/mixins/findId.js";

export default {
  data() {
    return {
      externalAuthCode: false,
      searchValue: "",
      searchValueTextField: "",
      submitState: false,
    };
  },

  mixins: [findIdMixin],

  computed: {
    // searchValue 유효성 Check(validation check searchValue)
    searchValueInvalidCheck() {
      let returnValue = false;
      if (this.submitState) {
        if (this.errors.has("searchValue")) {
          returnValue = true;
        } else {
          returnValue = false;
        }
      }
      this.searchValueTextField.valid === !returnValue
        ? ""
        : (this.searchValueTextField.valid = !returnValue);
      return returnValue;
    },
  },

  mounted() {
    this.setMaterialUi();
    // 외부 인증 사용 여부 API 호출(set External auth use)
    this.setExternalFind();
    //Store 초기화(init store)
    this.INIT_FINDID_STORE();
    this.$refs.searchValue.focus();
  },

  methods: {
    // Store 변이 정의(define store mutation)
    ...mapMutations("findId", [
      "SET_STEP1",
      "SET_AUTH_METHODS",
      "INIT_FINDID_STORE",
    ]),

    setMaterialUi() {
      this.searchValueTextField = new MDCTextField(
        document.querySelector("#searchValueEl")
      );
      this.searchValueTextField.useNativeValidation = false;

      const buttonRipple = [].map.call(
        document.querySelectorAll(".mdc-button"),
        function (el) {
          let button = new MDCRipple.attachTo(el);
          return button;
        }
      );
    },

    // get external auth use
    setExternalFind() {
      findApi
        .externalFind()
        .then((response) => {
          let responseData = response.data.data;
          this.externalAuthCode = responseData.externalAuthCode;
        })
        .catch((err) => {
          // responseData = err.response.data.meta
          // this.errorModal({content: responseData.errMsg}).then(() => {})
        });
    },

    // search information
    searchInfo() {
      this.$validator.validateAll().then((resultValid) => {
        this.submitState = true;
        if (resultValid) {
          // this.callLoginApi(loginType)
          let params = {
            value: this.searchValue,
            firstName: "",
            lastName: "",
            code: "",
          };

          this.SET_STEP1(params);

          // 계정 찾을 인증 수단 조회(get find account auth methods)
          findApi
            .findByInfo(params)
            .then((response) => {
              let responseData = response.data.data;

              this.SET_AUTH_METHODS(responseData);

              if (responseData.length) {
                this.$router.push({
                  name: "FindIdStep3",
                });
              } else {
                // this.errorModal({title:'검색 결과 없음', content: '검색하신 내용을 찾을 수 없습니다. 다른 정보를 이용해 다시 검색해주세요.'}).then(() => {})
                // this.$snackOpen({contents:'검색 결과가 없습니다. 검색하신 이메일 주소 또는 휴대폰 번호를 확인 후 다시 시도해주세요.'}).then(() => {})
                this.$snackOpen({
                  contents: this.$t("13") + " " + this.$t("14"),
                  btnDisplayYN: false,
                  btnDisplay: this.$t("58"),
                }).then(() => {});
                this.$refs.searchValue.focus();
              }
            })
            .catch((err) => {
              let responseData = err.response.data.meta;

              // this.errorModal({title:'검색 결과 없음', content: '검색하신 내용을 찾을 수 없습니다. 다른 정보를 이용해 다시 검색해주세요.'}).then(() => {})
              // this.$snackOpen({contents:'검색 결과가 없습니다. 검색하신 이메일 주소 또는 휴대폰 번호를 확인 후 다시 시도해주세요.'}).then(() => {})
              this.$snackOpen({
                contents: this.$t("13") + " " + this.$t("14"),
                btnDisplayYN: false,
                btnDisplay: this.$t("58"),
              }).then(() => {});
              this.$refs.searchValue.focus();
            });
        } else {
          this.$refs.searchValue.focus();
        }
      });
    },

    handleSearchValueInput(e) {
      this.searchValue = e.target.value;
    }
  },
};
</script>